import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Loader } from "./kit";

export const homeFor = (me) => (me?.account_type === "recruiter" ? "/recruiter" : "/coach");

export function Guard({ role, children }) {
  const { me, ready, isAdmin } = useAuth();
  if (!ready) return <div className="min-h-screen bg-[#0A0E1A] px-8"><Loader /></div>;
  if (!me) return <Navigate to="/login" replace />;
  if (role === "admin") return isAdmin ? children : <Navigate to={homeFor(me)} replace />;
  const isRecruiter = me.account_type === "recruiter";
  if ((role === "recruiter") !== isRecruiter) return <Navigate to={homeFor(me)} replace />;
  return children;
}
